const recurringGiftsActions = {
  SET_ADD_ON_GIFTS: "SET_ADD_ON_GIFTS",
  setAddOnGifts: (newAddOnGifts) => ({
    type: recurringGiftsActions.SET_ADD_ON_GIFTS,
    payload: newAddOnGifts,
  }),
  SET_AMOUNT: "setAmountInDollars",
  /**
   * @param {string} newValue - in dollars
   * @returns
   */
  setAmount: (newValue) => ({
    type: recurringGiftsActions.SET_AMOUNT,
    payload: newValue,
  }),
  CLEAR_EDIT_PANEL_ERROR: "clearEditPanelValidationError",
  clearEditPanelError: () => ({
    type: recurringGiftsActions.CLEAR_EDIT_PANEL_ERROR,
  }),
  SET_MAIN_GIFT_AMOUNT: "SET_MAIN_GIFT_AMOUNT",
  setMainGiftAmount: (newAmount) => ({
    type: recurringGiftsActions.SET_MAIN_GIFT_AMOUNT,
    payload: newAmount,
  }),
  ADD_DELETED_ADD_ON_GIFT: "ADD_DELETED_ADD_ON_GIFT",
  addDeletedAddOnGift: (addOnGiftID) => ({
    type: recurringGiftsActions.ADD_DELETED_ADD_ON_GIFT,
    payload: addOnGiftID,
  }),
};

export default recurringGiftsActions;
